<template>
  <div
    class="main-div"
  >
    <!--    card name-->
    <v-row
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start driver-label"
      >
        <div
          class="card-label--wrapper"
        >
          {{ item.type && item.type.name ? item.type.name : '--' }}
        </div>
      </v-col>

      <v-col
        class="d-flex justify-end actions"
      >
        <table-row-actions-menu
          :data-index="itemIndex"
          :config="actionsConfig"
          :table-data="data"
        />
      </v-col>
    </v-row>

    <!--    visible data section-->
    <div
      class="bottom-section"
    >
      <div class="bottom-style">
        <div>
          <div
            v-for="(dataObject, dataObjIndex) in getAllItemDetails()"
            :key="dataObjIndex"
            class="d-flex"
          >
            <div>
              {{ dataObject.label }}: &nbsp;
            </div>

            <div>
              {{ dataObject.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRowActionsMenu from '@/global/components/table/components/TableRowActionsMenu.vue'
import { isFunction } from '@/global/utils/utils'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'IdCardsGridBlock',

  components: {
    TableRowActionsMenu
  },

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    blockConfig: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    actionsConfig () {
      return {
        tableConfig: {
          actionsConfig: [
            showDetailsAction(this.$t, (event) => this.onShowCard(event)),
            deleteAction(this.$t, (event) => this.onCardDelete(event))
          ]
        }
      }
    }
  },

  methods: {
    getAllItemDetails () {
      return [
        {
          label: this.$t('people/person.pin_code'),
          value: this.item?.value || '--'
        }
      ]
    },

    onShowCard (event) {
      const { onEdit } = this.blockConfig || {}
      if (isFunction(onEdit)) {
        onEdit(event)
      }
    },

    onCardDelete (event) {
      const { onDelete } = this.blockConfig || {}
      if (isFunction(onDelete)) {
        onDelete(event)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-div {
  background-color: #65AD45;
  margin: 0;
  border: unset !important;
  border-radius: inherit;
}

.driver-label {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.card-label--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  color: #FFFFFF;
}

.bottom-style {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 200px;
  width: 200px;
  padding: 10px;
  color: #FFFFFF;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
}

::v-deep {
  .actions .v-icon {
    color: #FFFFFF;
  }
}
</style>
